/* eslint-disable no-loop-func */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SenseButton from './SenseButton';
import SoundAssetKeys from '../SoundAssetKeys';
import PushButton from './PushButton';
import FontKeys from '../FontKeys';
import AgainButtons from './AgainButtons';
import FeedbackCircle from './FeedbackCircle';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  create() {
    // console.log('Game');

    this.gameOver = false;
    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.snd = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.curAudio = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'LandscapeMainBackground_4x3', this).setOrigin(0, 0);

    this.resizeContainer = this.add.container();

    this.circleOuter = ABCyaPhaser.Images.addImage(0, 0, 'CircleLine', this.resizeContainer);
    this.circleOuter.x = this.mid.x;
    this.circleOuter.y = 768 / 2;
    this.circleOuter.alpha = 0;

    this.circleInner = ABCyaPhaser.Images.addImage(0, 0, 'CircleYellow', this.resizeContainer);
    this.circleInner.x = this.mid.x;
    this.circleInner.y = 768 / 2;
    this.circleInner.alpha = 0;

    const senselocs = [{ x: 512,y: 96 },{ x: 800,y: 324 },{ x: 683,y: 639 },{ x: 303,y: 596 },{ x: 241,y: 296 }];
    const charstypes = gameData.SENSES_CHARACTERS;// //;["Smell", "Sight", "Taste", "Hear", "Touch"];
    let item = null;
    this.senseButtons = [];
    for (let i = 0; i < charstypes.length; i++) {
      item = new SenseButton(this, charstypes[i].name, true);
      item.x = senselocs[i].x;
      item.y = senselocs[i].y;
      this.senseButtons.push(item);
      this.resizeContainer.add(item);
      item.bg.setInteractive();
      item.bg.on('pointerup', () => {this.senseClicked(this.senseButtons[i]);});
    }

    this.txtDisplay = ABCyaPhaser.Text.addText(0, 0, 32, '0xFFFFFF', FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('question_data.intro_text'), this.resizeContainer, true).setWordWrapWidth(350);
    this.txtDisplay.x = this.mid.x;

    this.btnNext = new PushButton(this, 'Button', 'ButtonArrow', 8,0,() => {this.initQuestions();});
    this.btnNext.x = this.mid.x * 2 - this.btnNext.getBounds().width + 222;
    this.btnNext.y = this.mid.y * 2 - this.btnNext.getBounds().height - 15;

    this.btnRepeat = new PushButton(this, 'Button', 'Label_Repeat', null, null, () => {this.clickRepeat();});
    this.btnRepeat.x = this.mid.x * 2 - this.btnRepeat.getBounds().width + 222;
    this.btnRepeat.y = this.mid.y * 2 - this.btnRepeat.getBounds().height - 15;
    this.btnRepeat.setVisible(false);

    this.feedbackCircle = new FeedbackCircle(this, '0xFFCC00', gameData.questionData.correctFeedback, gameData.questionData.incorrectFeedback);
    this.feedbackCircle.alpha = 0;
    this.resizeContainer.add(this.feedbackCircle);

    this.againButtons = new AgainButtons(this);
    this.againButtons.x = this.mid.x - this.againButtons.getBounds().width / 2 + this.againButtons.btnQuiz.bgSize / 2;
    this.againButtons.y = 768 - 140;
    this.againButtons.on('QUIZ', () => {this.restartQuiz();});
    this.againButtons.on('LEARN', () => {this.restartLearn();});
    this.againButtons.setVisible(false);

    this.layoutRatio();
    this.startIntro();
  }

  startIntro() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop2, this);

    this.circleInner.scaleX = 0;
    this.circleInner.scaleY = 0;
    this.circleInner.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.circleInner, 320, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

    this.txtDisplay.text = ABCyaPhaser.Localization.instance.getLocalizedString('question_data.intro_text');
    this.txtDisplay.y = this.mid.y;
    this.txtDisplay.scaleX = 0;
    this.txtDisplay.scaleY = 0;
    this.txtDisplay.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.txtDisplay, 320, { delay: 200, scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.startSound();
    });
  };

  startSound() {
    ABCyaPhaser.Audio.playSound(gameData.questionData.introAudio, this.snd);
    this.snd.once('complete', () => {this.initShowSenses();});
  };

  initShowSenses(e) {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop2, this);

    this.circleOuter.scaleX = 0;
    this.circleOuter.scaleY = 0;
    this.circleOuter.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.circleOuter, 620, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Back.Out, () => {
      this.showSense();
    });
  };

  showSense() {
    const len = this.senseButtons.length;
    for (let i = 0; i < len; i++) {
      this.senseButtons[i].popin();
    }

    this.btnNext.initLayout();

    this.btnNext.bg.setInteractive();

    ABCyaPhaser.Tweens.addTween(this.btnNext, 400, { x: this.mid.x * 2 - this.btnNext.getBounds().width + 2 }, Phaser.Math.Easing.Quadratic.Out);
  };

  initQuestions() {
    this.btnNext.bg.disableInteractive();

    ABCyaPhaser.Tweens.addTween(this.btnNext, 400, { x: this.mid.x * 2 + 2 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.btnRepeat, 400, { x: this.mid.x * 2 - this.btnNext.getBounds().width + 2 }, Phaser.Math.Easing.Quadratic.Out);

    this.btnRepeat.setVisible(true);
    this.btnRepeat.bg.setInteractive();

    this.questionSet = gameData.questionData.questions.slice();
    this.questionSet = Phaser.Utils.Array.Shuffle(this.questionSet);
    this.nextQuestion();
  };

  nextQuestion() {
    this.txtDisplay.scaleX = 0;
    this.txtDisplay.scaleY = 0;

    if (this.questionSet.length > 0) {
      this.curQuestion = this.questionSet.pop();
      this.txtDisplay.text = ABCyaPhaser.Localization.instance.getLocalizedString(this.curQuestion.text);

      ABCyaPhaser.Tweens.addTween(this.txtDisplay, 420, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Linear);

      if (this.curAudio) this.curAudio.stop();
      ABCyaPhaser.Audio.playSound(this.curQuestion.audiofile, this.curAudio);
    }
    else {
      // console.log('out of questions', this.curQuestion);
      ABCyaPhaser.Tweens.addTween(this.btnRepeat, 400, { x: this.mid.x * 2 + 2 }, Phaser.Math.Easing.Quadratic.Out);

      this.gameOver = true;
      this.txtDisplay.text = ABCyaPhaser.Localization.instance.getLocalizedString('question_data.finished_text');

      ABCyaPhaser.Tweens.addTween(this.txtDisplay, 420, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Linear);

      if (this.curAudio) this.curAudio.stop();
      ABCyaPhaser.Audio.playSound(gameData.questionData.finishedAudio, this.curAudio);
      this.curAudio.once('complete', () => {this.showFinish();});
    }
  };

  clickRepeat() {
    if (this.curAudio) this.curAudio.stop();
    if (this.curQuestion) ABCyaPhaser.Audio.playSound(this.curQuestion.audiofile, this.curAudio);
  };

  checkAnswer(senseClicked) {
    const correct = this.curQuestion.correctSense === senseClicked;
    if (this.snd) this.snd.stop();

    this.feedbackSound = this.feedbackCircle.showFeedback(correct);
    ABCyaPhaser.Audio.playSound(this.feedbackSound, this.snd);

    this.feedbackCircle.scaleX = 0;
    this.feedbackCircle.scaleY = 0;

    ABCyaPhaser.Tweens.addTween(this.feedbackCircle, 330, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Linear);

    if (this.curQuestion.correctSense === senseClicked) {
      // console.log('Correct!');
      this.curQuestion = null;
      if (this.curAudio) this.curAudio.stop();
      this.snd.once('complete', () => {this.questionFinished();});
    }
    else {
      // console.log('Incorrect!');
    }
    return correct;
  };

  questionFinished() {
    ABCyaPhaser.Tweens.addTween(this.feedbackCircle, 440, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Linear);
    this.feedbackCircle.curSense = null;

    ABCyaPhaser.Tweens.addTween(this.txtDisplay, 440, { alpha: 0 }, Phaser.Math.Easing.Linear);

    this.time.delayedCall(500, () => {this.nextQuestion();});
  };

  senseClicked(e) {
    if (this.gameOver) return;

    const btn = e;
    if (this.curQuestion) {
      if (this.feedbackCircle.curSense === btn.senseName) return;
      const correct = this.checkAnswer(btn.senseName);

      this.feedbackCircle.x = btn.x;
      this.feedbackCircle.y = btn.y;
      this.feedbackCircle.curSense = btn.senseName;
    }
    else {
      ABCyaPhaser.Audio.playOneShot(btn.senseName, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
  };

  showChar(sense) {
    this.charDisplay.setFrame(`Char_${sense}`);

    this.charDisplay.scaleX = .8;
    this.charDisplay.scaleY = 0.8;
    this.charDisplay.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.charDisplay, 420, { scaleX: 0.4, scaleY: 0.4, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  };

  showFinish() {
    this.againButtons.alpha = 0;
    this.againButtons.setVisible(true);

    this.time.delayedCall(900, () => {this.initFinishedButtons();});

    ABCyaPhaser.Tweens.addTween(this.circleOuter, 520, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.Back.In);

    const len = this.senseButtons.length;
    for (let i = 0; i < len; i++) {
      this.senseButtons[i].popout();
    }
  };

  initFinishedButtons() {
    this.againButtons.popinButtons();

    ABCyaPhaser.Tweens.addTween(this.againButtons, 800, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  };

  restartQuiz() {
    if (this.gameOver) {
      this.againButtons.alpha = 0;
      this.gameOver = false;
      this.curQuestion = null;
      this.startIntro();
    }
  };

  restartLearn() {
    if (this.gameOver) this.scene.start('Slides');
  };

  doGameOver() {
    this.gameOver = true;
  };

  layoutRatio() {
    this.resizeContainer.scaleX = 1;
    this.resizeContainer.scaleY = 1.0;
    this.resizeContainer.x = 0;
    this.resizeContainer.y = 0;

    this.btnNext.y = this.mid.y * 2 - this.btnNext.getBounds().height - 15;
    this.btnRepeat.y = this.mid.y * 2 - this.btnRepeat.getBounds().height - 15;
  };
}